module.exports = __webpack_public_path__ + "img/1541273758.28a662b5.jpg";